module.exports = __webpack_public_path__ + "static/media/404.a856e094.svg";